import React, { useMemo, useState } from 'react'
import faqItems from 'virtual:faq'

// audience: 'user' (main app) or 'admin' (admin portal). Entries marked
// 'both' surface in either. Categories with no matching entries are hidden.
export function FAQPage({ audience = 'user' }) {
  const [openIndex, setOpenIndex] = useState(null)

  const sections = useMemo(
    () => faqItems.filter((s) => s.audience === 'both' || s.audience === audience),
    [audience],
  )

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  let globalIndex = 0

  return (
    <div>
      <h2 style={styles.heading}>Frequently asked questions</h2>
      <p style={styles.subtitle}>Common questions about using Soundcheck.</p>
      <div style={styles.list}>
        {sections.map((section) => (
          <div key={section.category}>
            <h3 style={styles.categoryTitle}>{section.category}</h3>
            <div style={styles.categoryList}>
              {section.questions.map((faq) => {
                const idx = globalIndex++
                const isOpen = openIndex === idx
                return (
                  <button
                    key={idx}
                    style={styles.card}
                    onClick={() => toggle(idx)}
                    aria-expanded={isOpen}
                  >
                    <div style={styles.cardHeader}>
                      <span style={styles.question} dangerouslySetInnerHTML={{ __html: faq.q }} />
                      <span style={styles.chevron}>{isOpen ? '−' : '+'}</span>
                    </div>
                    {isOpen && <p style={styles.answer} dangerouslySetInnerHTML={{ __html: faq.a }} />}
                  </button>
                )
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const styles = {
  heading: { fontSize: '18px', fontWeight: 700, margin: '0 0 4px' },
  subtitle: { fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 20px' },
  list: { display: 'flex', flexDirection: 'column', gap: '24px' },
  categoryTitle: { fontSize: '13px', fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', margin: '0 0 8px', letterSpacing: '0.5px' },
  categoryList: { display: 'flex', flexDirection: 'column', gap: '8px' },
  card: {
    border: '1px solid var(--border)',
    borderRadius: '8px',
    padding: '14px 20px',
    background: 'var(--card-bg, #fff)',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    font: 'inherit',
    color: 'inherit',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  question: { fontSize: '14px', fontWeight: 600 },
  chevron: { fontSize: '16px', color: 'var(--text-secondary)', flexShrink: 0 },
  answer: { fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.6, margin: '10px 0 0' },
}
